import {
  pathOr,
  prop,
} from 'ramda';
import { createSelector } from 'reselect';

import { RootState } from '../types';

export const userSelector = (state: RootState) => state.user;

export const sessionStartSelector = createSelector(
  userSelector,
  prop('sessionStart'),
);

export const evoWrapperBalanceSelector = createSelector(
  userSelector,
  (user) => user.evoWrapperBalance ?? null
);
export const evoWrapperBalanceVersionSelector = createSelector(
  userSelector,
  (user) => user.evoWrapperBalanceVersion ?? null
);
export const evoWalletBalanceVersionSelector = createSelector(
  userSelector,
  (user) => user.evoWalletBalanceVersion ?? null
);

export const userNicknameSelector = createSelector(userSelector, prop('nickname'));
export const currencySelector = createSelector(userSelector, prop('currency'));
export const userIdSelector = createSelector(userSelector, prop('uid'));
export const userRCISelector = createSelector(userSelector, prop('rci'));
export const userHistoryUrlSelector = createSelector(
  userSelector,
  prop('historyurl'),
);

export const clientIdSelector = createSelector(userSelector, prop('clientId'));

// Default currency to $
// TODO: check if this default should apply
export const userCurrencySelector = pathOr('$', [ 'user', 'currency' ]);

export const userBalanceSelector = pathOr(0, [ 'user', 'balance' ]);

export const userRealtimeBalanceSelector = pathOr(0, [ 'user', 'realtimeBalance' ]);

export const netPositionValueSelector = createSelector(
  userSelector,
  (user) => user.netPosition
);
export const hasInitializedBalanceSelector = createSelector(
  userSelector,
  (user) => user.hasInitializedBalance
);
export const userOperatorIdSelector = createSelector(
  userSelector,
  (user) => user.operatorId
);
